import React from 'react';
import { XCircle, AlertTriangle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 bg-brand-light" data-id="element-192">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-193">
        <div className="bg-white rounded-[2rem] p-8 md:p-12 shadow-xl shadow-rose-100/50 border border-rose-100 relative overflow-hidden" data-id="element-194">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-brand-primary to-brand-secondary" data-id="element-195"></div>

          <div className="text-center mb-10" data-id="element-196">
            <h2 className="text-3xl md:text-4xl font-heading font-medium italic text-brand-primary mb-6 leading-tight" data-id="element-197">
              "El 'Sueño Americano' no debería costarte ver crecer a tus hijos."
            </h2>
            <p className="text-lg text-brand-dark/80 leading-relaxed max-w-2xl mx-auto" data-id="element-198">
              Sabemos lo que se siente. 40 horas semanales (o más) por un sueldo
              que apenas cubre lo básico. Pedir permiso para ir al médico.
              Sentir que vives para trabajar en lugar de trabajar para vivir.
              <br data-id="element-199" />
              <br data-id="element-200" />
              <span className="font-bold text-brand-dark" data-id="element-201">
                Mujer, no viniste a este país a ser esclava de un sistema.
                Viniste a triunfar.
              </span>
            </p>
          </div>

          <div className="my-8 h-px bg-rose-100 w-3/4 mx-auto" data-id="element-202" />

          <h3 className="text-xl font-bold text-brand-dark mb-8 text-center uppercase tracking-widest text-sm" data-id="element-203">
            Por qué los métodos "tradicionales" fallan:
          </h3>

          <div className="space-y-4" data-id="element-204">
            <div className="flex items-start p-5 bg-rose-50 rounded-2xl border border-rose-100 transition-transform hover:scale-[1.01]" data-id="element-205">
              <XCircle className="w-6 h-6 text-brand-primary mr-4 mt-0.5 flex-shrink-0" data-id="element-206" />
              <div data-id="element-207">
                <span className="font-bold text-brand-dark block text-lg mb-1" data-id="element-208">
                  Las encuestas pagan centavos
                </span>
                <span className="text-brand-muted" data-id="element-209">
                  Inviertes horas valiosas de tu vida para ganar migajas que no
                  pagan ni el café. Tu tiempo vale oro.
                </span>
              </div>
            </div>

            <div className="flex items-start p-5 bg-rose-50 rounded-2xl border border-rose-100 transition-transform hover:scale-[1.01]" data-id="element-210">
              <XCircle className="w-6 h-6 text-brand-primary mr-4 mt-0.5 flex-shrink-0" data-id="element-211" />
              <div data-id="element-212">
                <span className="font-bold text-brand-dark block text-lg mb-1" data-id="element-213">
                  El MLM arruina amistades
                </span>
                <span className="text-brand-muted" data-id="element-214">
                  Tener que perseguir a tus amigas y familiares para venderles
                  productos que no necesitan. Eso no es libertad.
                </span>
              </div>
            </div>

            <div className="flex items-start p-5 bg-rose-50 rounded-2xl border border-rose-100 transition-transform hover:scale-[1.01]" data-id="element-215">
              <XCircle className="w-6 h-6 text-brand-primary mr-4 mt-0.5 flex-shrink-0" data-id="element-216" />
              <div data-id="element-217">
                <span className="font-bold text-brand-dark block text-lg mb-1" data-id="element-218">
                  Trabajos de oficina mal pagados
                </span>
                <span className="text-brand-muted" data-id="element-219">
                  Data entry o servicio al cliente que te encadenan a un
                  escritorio por el salario mínimo. Sigues siendo una empleada.
                </span>
              </div>
            </div>
          </div>

          <div className="mt-12 text-center bg-brand-dark text-white p-6 rounded-2xl" data-id="element-220">
            <p className="text-xl font-heading italic" data-id="element-221">
              Existe una mejor manera. Y está diseñada{' '}
              <span className="text-brand-secondary font-bold not-italic" data-id="element-222">
                solo para nosotras.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}